<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column bdr-b">
    <div class="row f-row mb-2 markets-chart-title d-flex align-items-center">
      <div class="col col-6"></div>
      <slot name="spot"></slot>
    </div>
    <NavbarCustom
      :selectedNavLink="selectedNavLink"
      :linkList="linkList"
      :isLight="true"
      @eventOnClientSelect="eventOnClientSelect"
    />
    <CPOTable
      v-if="selectedNavLink === 0"
      :currMonth="currMonth"
      :fepHistData="currMonth ? fepHistData : fepHistData2"
      :fepTableData="fepTableData"
      :freight="freight"
      :showLoadingFepTable="showLoadingFepTable"
      :tariff="tariff"
      @eventOnUserSelectMonth="onUserSelectMonth"
      @eventOnUserFreightChange="onUserFreightChange"
      @eventOnUserTariffChange="onUserTariffChange"
    />
    <CPOFEP
      v-else-if="selectedNavLink === 1"
      :allData="allDataFEP"
      :aveDataFEP="aveDataFEP"
      :colorTheme="colorTheme"
      :cpoInUSDOrMYR="cpoInUSDOrMYR"
      :expandLeft="expandLeft"
      :expandRight="expandRight"
      :freight="freight"
      :fwdUSDCOP="fwdUSDCOPSliced"
      :fwdUSDMYR="fwdUSDMYRSliced"
      :hideLeft="hideLeft"
      :hideRight="hideRight"
      :histFEP="histFEPSliced"
      :histUSDCOPMonth="histUSDCOPMonth"
      :histUSDCOPSliced="histUSDCOPSliced"
      :histUSDMYRMonth="histUSDMYRMonth"
      :histUSDMYRSliced="histUSDMYRSliced"
      :interval="interval"
      :malaysiaFwdData="malaysiaFwdDataSliced"
      :malaysiaFwdUSDData="malaysiaFwdUSDDataSliced"
      :malaysiaHistDataMonth="malaysiaHistDataMonth"
      :malaysiaHistDataSliced="malaysiaHistDataSliced"
      :malaysiaUSDHistDataMonth="malaysiaUSDHistDataMonth"
      :malaysiaUSDHistDataSliced="malaysiaUSDHistDataSliced"
      :monthFEP="monthFEP"
      :pickedIntervalHistory="pickedIntervalHistory"
      :processData="processData"
      :renderFEPSignal="renderFEPSignal"
      :renderPriceChartSignal="renderPriceChartSignal"
      :renderRatesChartSignal="renderRatesChartSignal"
      :selectedCOPOrMYR="selectedCOPOrMYR"
      :showLoadingAllCalcs="showLoadingAllCalcs"
      :tariff="tariff"
      :xRange="xRange"
      :xRangeFEP="xRangeFEP"
      :zoomFinal="zoomFinal"
      :zoomInitial="zoomInitial"
      @eventOnExpandLeftAnimation="expandLeftAnimation"
      @eventOnExpandRightAnimation="expandRightAnimation"
      @eventOnUserSelectCPOCurr="onUserSelectCPOCurr"
      @eventOnUserSelectCurr="onUserSelectCurr"
      @eventOnChangeInterval="onChangeInterval"
      @eventOnMinRange="eventMinRange"
      @eventOnMaxRange="eventMaxRange"
      @eventOnUserFreightChange="onUserFreightChange"
      @eventOnUserTariffChange="onUserTariffChange"
    />
    <CPOImpoExpo
      v-else-if="selectedNavLink === 2"
      :allData="allDataRotterdam"
      :aveDataFEP="aveDataRotterdam"
      :colorTheme="colorTheme"
      :expandLeft="expandLeft"
      :expandRight="expandRight"
      :freight="freightRott"
      :fwdUSDCOP="fwdUSDCOPSimpleSliced"
      :hideLeft="hideLeft"
      :hideRight="hideRight"
      :histFEP="histRottImpoExpo"
      :histUSDCOPMonth="histUSDCOPMonth"
      :histUSDCOPSliced="histUSDCOPSliced"
      :interval="interval"
      :monthFEP="monthRotterdam"
      :pickedIntervalHistory="pickedIntervalHistory"
      :processData="processData"
      :renderFEPSignal="renderFEPSignal"
      :renderPriceChartSignal="renderPriceChartSignal"
      :renderRatesChartSignal="renderRatesChartSignal"
      :rotterdamFwdData="rotterdamFwdDataSliced"
      :rotterdamHistDataMonth="rotterdamHistDataMonth"
      :rotterdamHistDataSliced="rotterdamHistDataSliced"
      :showLoadingAllCalcs="showLoadingAllCalcs"
      :tariff="tariffRott"
      :xRange="xRange"
      :zoomFinal="zoomFinal"
      :zoomInitial="zoomInitial"
      @eventOnExpandLeftAnimation="expandLeftAnimation"
      @eventOnExpandRightAnimation="expandRightAnimation"
      @eventOnUserSelectCPOCurr="onUserSelectCPOCurr"
      @eventOnUserSelectCurr="onUserSelectCurr"
      @eventOnChangeInterval="onChangeInterval"
      @eventOnMinRange="eventMinRange"
      @eventOnMaxRange="eventMaxRange"
      @eventOnUserFreightChange="onUserFreightChangeRott"
      @eventOnUserTariffChange="onUserTariffChangeRott"
    />
    <CPOColComparison
      v-else-if="selectedNavLink === 3"
      :allData="allDataFEP"
      :allDataRott="allDataRotterdam"
      :aveDataFEP="aveDataFEP"
      :aveDataRott="aveDataRotterdam"
      :colorTheme="colorTheme"
      :comp="comp"
      :compRott="compRott"
      :freight="freight"
      :freightRott="freightRott"
      :histFEP="histFEPSliced"
      :histRott="histRottImpoExpo"
      :histRottMonthly="histRottImpoExpoMonthly"
      :interval="interval"
      :monthFEP="monthFEP"
      :monthRott="monthRotterdam"
      :pickedIntervalHistory="pickedIntervalHistory"
      :processData="processData"
      :renderFEPSignal="renderFEPSignal"
      :showLoadingAllCalcs="showLoadingAllCalcs"
      :tariff="tariff"
      :tariffRott="tariffRott"
      :xRange="xRange"
      :zoomFinal="zoomFinal"
      :zoomInitial="zoomInitial"
      @eventOnChangeInterval="onChangeInterval"
      @eventOnMinRange="eventMinRange"
      @eventOnMaxRange="eventMaxRange"
      @eventOnUserFreightChange="onUserFreightChange"
      @eventOnUserTariffChange="onUserTariffChange"
      @eventOnUserFreightChangeRott="onUserFreightChangeRott"
      @eventOnUserTariffChangeRott="onUserTariffChangeRott"
      @eventOnUserCompChange="onUserCompChange"
      @eventOnUserCompChangeRott="onUserCompChangeRott"
    />
    <CPOCessionCompensation
      v-else
      :dataVar="histFEP[histFEP.length - 1]"
      :fepHistData="
        +fepTableData[0].date === +histFEP[histFEP.length - 1].date
          ? fepHistData
          : fepHistData2
      "
      :fepTableData="fepTableData"
      :showLoading="showLoadingFEP"
    />
  </div>
</template>

<script>
import CPOCessionCompensation from "@/components/markets/CPOCessionCompensation";
import CPOColComparison from "@/components/markets/CPOColComparison";
import CPOFEP from "@/components/markets/CPOFEP";
import CPOImpoExpo from "@/components/markets/CPOImpoExpo";
import CPOTable from "@/components/markets/CPOTable";
import NavbarCustom from "@/components/NavbarCustom";
import { getColombiaCPO } from "@/_core/data/api_calls/getColombiaCPO";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { getFEPData } from "@/_core/data/api_calls/FEP/getFEP";
import { populateTableFEPComp } from "@/_core/data/Markets";
import { setMax } from "@/_core/data/Advanced";
import { lengthByDate, timeParseNull2 } from "@/_core/_helpers/_helpers";
import {
  tIntervalsAnalytics,
  formatNumber,
} from "@/_core/_helpers/_parametric_tools";
import { timeFormat } from "d3";

export default {
  name: "CPOColombia",
  components: {
    CPOCessionCompensation,
    CPOColComparison,
    CPOFEP,
    CPOImpoExpo,
    CPOTable,
    NavbarCustom,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    commoditySpecs: { required: true },
    currencySpecs: { required: true },
    // ============ Data Classes ===============
    processData: { required: true },
  },
  data() {
    return {
      // ==== New variables
      fepHistData: [],
      fepTableData: [],
      fepHistData2: [],
      currMonth: true,
      showLoadingFepTable: true,
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 11),
      ),
      // ============= fep signals
      showLoadingFEP: false,
      showLoadingFEPCalcs: false,
      // ============= cpo malaysia signals
      showLoadingMAL: false,
      showLoadingFwdMAL: false,
      showLoadingMalCalcs: false,
      // ============= cpo rotterdam signals
      showLoadingROTT: false,
      showLoadingFwdROTT: false,
      showLoadingRottCalcs: false,
      // ============= cpo malaysia USD signals
      showLoadingMALUSD: false,
      showLoadingMALUSDCalcs: false,
      // ============= usdcop signals
      showLoadingUSDCOP: false,
      showLoadingFwdUSDCOP: false,
      showLoadingUSDCOPCalcs: false,
      // ============= usdmyr signals
      showLoadingUSDMYR: false,
      showLoadingFwdUSDMYR: false,
      showLoadingUSDMYRCalcs: false,
      // === animations
      hideLeft: false,
      hideRight: false,
      expandLeft: false,
      expandRight: false,
      renderPriceChartSignal: 0,
      renderRatesChartSignal: 0,
      renderFEPSignal: 0,
      selectedNavLink: 0,
      pickedIntervalHistory: "6M",
      interval: "day",
      tIntervals: tIntervalsAnalytics,
      xRange: [
        new Date(),
        new Date(new Date().setMonth(new Date().getMonth() + 1)),
        new Date(new Date().setMonth(new Date().getMonth() + 2)),
      ],
      xRangeFEP: [
        new Date(),
        new Date(new Date().setMonth(new Date().getMonth() + 1)),
        new Date(new Date().setMonth(new Date().getMonth() + 2)),
      ],
      zoomInitial: 0,
      zoomFinal: 1,
      linkList: [
        "FEP",
        "FEP SWAPS",
        "Rotterdam SWAPS",
        "SWAPS Comparison",
        "Cession | Compensation",
      ],
      cpoInUSDOrMYR: "usd",
      selectedCOPOrMYR: "cop",
      // === variables
      maxContractsPerCommodity: 12,
      currencyPKs: [],
      malaysiaHistData: [],
      malaysiaHistDataSliced: [],
      malaysiaHistDataMonth: [],
      malaysiaUSDHistData: [],
      malaysiaUSDHistDataSliced: [],
      malaysiaUSDHistDataMonth: [],
      rotterdamHistDataRaw: [],
      rotterdamHistData: [],
      rotterdamHistDataSliced: [],
      rotterdamHistDataMonth: [],
      histUSDCOP: [],
      histUSDCOPSliced: [],
      histUSDCOPMonth: [],
      histUSDMYR: [],
      histUSDMYRSliced: [],
      histUSDMYRMonth: [],
      malaysiaFwdDataRaw: [],
      malaysiaFwdData: [],
      malaysiaFwdUSDData: [],
      rotterdamFwdDataRaw: [],
      rotterdamFwdData: [],
      fwdUSDCOP: [],
      fwdUSDCOPSimple: [],
      fwdUSDMYR: [],
      malaysiaFwdDataSliced: [],
      malaysiaFwdUSDDataSliced: [],
      rotterdamFwdDataSliced: [],
      fwdUSDCOPSliced: [],
      fwdUSDCOPSimpleSliced: [],
      fwdUSDMYRSliced: [],
      histFEP: [
        {
          pk_idfephistorical: 0,
          date: "2022-01-01T05:00:00.000Z",
          ave_date: null,
          close: 1,
          bmd: 1,
          arg: 1,
          usa: 1,
          tallow: 1,
          stearin: 1,
          freight_bmd: 1,
          freight_arg: 1,
          freight_usa: 1,
          freight_tallow: 1,
          freight_stearin: 1,
          tariff_bmd: 0,
          tariff_arg: 0,
          tariff_usa: 0,
          tariff_tallow: 0,
          tariff_stearin: 0,
          cession: null,
          cession_north_g1: 0,
          cession_north_g2: 0,
          cession_north_g3: 0,
          cession_north_g4: 0,
          cession_center_g1: 0,
          cession_center_g2: 0,
          cession_center_g3: 0,
          cession_center_g4: 0,
          cession_east_g1: 0,
          cession_east_g2: 0,
          cession_east_g3: 0,
          cession_east_g4: 0,
          cession_south_east_g1: 0,
          cession_south_east_g2: 0,
          cession_south_east_g3: 0,
          cession_south_east_g4: 0,
          compensation: null,
          compensation_north_g1: 0,
          compensation_north_g2: 0,
          compensation_north_g3: 0,
          compensation_north_g4: 0,
          compensation_center_g1: 0,
          compensation_center_g2: 0,
          compensation_center_g3: 0,
          compensation_center_g4: 0,
          compensation_east_g1: 0,
          compensation_east_g2: 0,
          compensation_east_g3: 0,
          compensation_east_g4: 0,
          compensation_south_east_g1: 0,
          compensation_south_east_g2: 0,
          compensation_south_east_g3: 0,
          compensation_south_east_g4: 0,
          sales_colombia: 100,
          sales_g1: 0,
          sales_g2: 0,
          sales_g3: 0,
          sales_g4: 0,
          sales_north_g1: 0,
          sales_center_g1: 0,
          sales_east_g1: 0,
          sales_south_east_g1: 0,
          sales_north_g2: 0,
          sales_center_g2: 0,
          sales_east_g2: 0,
          sales_south_east_g2: 0,
          sales_north_g3: 0,
          sales_center_g3: 0,
          sales_east_g3: 0,
          sales_south_east_g3: 0,
          sales_north_g4: 0,
          sales_center_g4: 0,
          sales_east_g4: 0,
          sales_south_east_g4: 0,
          rott_ave: 1,
          trm_ave: 4,
          price_g2: null,
          price_g3: null,
          price_g4: null,
          price_north_g1: 1,
          price_center_g1: 1,
          price_east_g1: 1,
          price_south_east_g1: 1,
          price_north_g2: 1,
          price_center_g2: 1,
          price_east_g2: 1,
          price_south_east_g2: 1,
          price_north_g3: 1,
          price_center_g3: 1,
          price_east_g3: 1,
          price_south_east_g3: 1,
          price_north_g4: 1,
          price_center_g4: 1,
          price_east_g4: 1,
          price_south_east_g4: 1,
          adjustment_factor: 0,
          id: 1,
          open: 1,
          high: 1,
          low: 1,
        },
      ],
      histFEPSliced: [],
      histRottImpoExpo: [],
      histRottImpoExpoMonthly: [],
      monthFEP: [],
      monthRotterdam: [],
      allDataFEP: [],
      allDataRotterdam: [],
      aveDataFEP: { date: new Date(), bmd: 0, usdcop: 0, close: 0 },
      aveDataRotterdam: { date: new Date(), bmd: 0, usdcop: 0, close: 0 },
      freight: 82.3,
      tariff: 0,
      comp: -150000,
      freightRott: -110,
      tariffRott: 0,
      compRott: 100000,
      firstDay: null,
      commodityNumber: 0,
      commodityContract: 0,
      currencyNumber: 12,
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 11),
      ),
      spotUSDCOP: 0,
      updatedAtUSDCOP: "...",
      spotUSDMYR: 0,
      updatedAtUSDMYR: "...",
      commodityNames: [],
      commodityById: {},
      contractsPerCommodity: 15,
      counter: 0,
    };
  },
  created() {
    // ============= cpo malaysia signals
    this.showLoadingFEP = true;
    this.showLoadingFEPCalcs = true;
    // ============= cpo malaysia signals
    this.showLoadingMAL = true;
    this.showLoadingFwdMAL = true;
    this.showLoadingMalCalcs = true;
    // ============= cpo rotterdam signals
    this.showLoadingROTT = true;
    this.showLoadingFwdROTT = true;
    this.showLoadingRottCalcs = true;
    // ============= cpo malaysia USD signals
    this.showLoadingMALUSD = true;
    this.showLoadingMALUSDCalcs = true;
    // ============= usdcop signals
    this.showLoadingUSDCOP = true;
    this.showLoadingFwdUSDCOP = true;
    this.showLoadingUSDCOPCalcs = true;
    // ============= usdmyr signals
    this.showLoadingUSDMYR = true;
    this.showLoadingFwdUSDMYR = true;
    this.showLoadingUSDMYRCalcs = true;

    const date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

    let _this = this;
    this["fepTableData"] = [];
    this["showLoadingFepTable"] = true;
    // ============= get fep
    getFEPData(this, "histFEP", "showLoadingFEP");
    getColombiaCPO()
      .then((data) => {
        data = JSON.parse(JSON.stringify(data));
        data.forEach(function(d) {
          d.date = timeParseNull2(d.date);
        });
        _this["fepHistData"] = data
          .filter((d) => d.is_hist === 1)
          .map(function(d) {
            return {
              date: d.date,
              cop: d.cop,
              myr: d.myr,
              bmd: d.bmd,
              bmd_usd: d.bmd_usd,
              rott: d.rott,
              contract_rott: d.contract_rott,
            };
          });
        _this["fepHistData2"] = data
          .filter((d) => d.is_hist === 0)
          .map(function(d) {
            return {
              date: d.date,
              cop: d.cop,
              myr: d.myr,
              bmd: d.bmd,
              bmd_usd: d.bmd_usd,
              rott: d.rott,
              contract_rott: d.contract_rott,
            };
          });
        _this["fepTableData"] = data
          .filter((d) => d.is_hist === 2)
          .map(function(d) {
            return {
              date: d.date,
              cop: d.cop,
              cop_fwd: d.cop_fwd,
              cop_ave: d.cop_ave,
              cop_first: d.cop_first,
              myr: d.myr,
              myr_fwd: d.myr_fwd,
              myr_ave: d.myr_ave,
              myr_first: d.myr_first,
              bmd: d.bmd,
              bmd_fwd: d.bmd_fwd,
              bmd_ave: d.bmd_ave,
              futures_1: d.futures_1,
              contract_1: d.contract_1,
              futures_2: d.futures_2,
              contract_2: d.contract_2,
              rott: d.rott,
              contract_rott: d.contract_rott,
              n_1: d.n_1,
              n_2: d.n_2,
            };
          });
        _this["showLoadingFepTable"] = false;
      })
      .catch(function(error) {
        _this.showLoadingFepTable = false;
        console.log(error);
      });

    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  mounted() {
    let _this = this;
    this.currencyPKs = this.currencySpecs.map((d) => d.pk_i_idcurrency);
    this.commodityNames = this.commoditySpecs.map((d) => d.fk_idproduct);
    this.commodityById = {};
    this.commoditySpecs.forEach(function(d) {
      _this.commodityById[d.pk_idcommodity] = d.fk_idproduct;
    });
    // ============= get cpo malaysia data
    let idx = this.commodityNames.indexOf("cpo mal myr");
    this.commodityNumber = this.commoditySpecs[idx].pk_idcommodity;
    this.commodityContract = this.commoditySpecs[idx].selected_contract;
    this.showLoadingMAL = true;
    this.showLoadingMALUSD = true;
    this.showLoadingMalCalcs = true;
    getCandleData(this, "commodity", {
      commodityNumber: this.commodityNumber,
      contract: this.commodityContract,
    })
      .then((data) => {
        this["malaysiaHistData"] = data;
        this["showLoadingMAL"] = false;
      })
      .catch(function(error) {
        _this["showLoadingMAL"] = false;
        _this["malaysiaHistData"] = [];
        console.log(error);
      });
    // ============= get cif rotterdam data
    idx = this.commodityNames.indexOf("cpo cif rott");
    this.commodityNumber = this.commoditySpecs[idx].pk_idcommodity;
    this.commodityContract = 1;
    this.showLoadingROTT = true;
    getCandleData(this, "commodity", {
      commodityNumber: this.commodityNumber,
      contract: this.commodityContract,
    })
      .then((data) => {
        this["rotterdamHistData"] = data;
        this["showLoadingROTT"] = false;
      })
      .catch(function(error) {
        _this["showLoadingROTT"] = false;
        _this["rotterdamHistData"] = [];
        console.log(error);
      });
    // ============= get USDCOP data
    this.currencyNumber = 12;
    this.showLoadingUSDCOP = true;
    getCandleData(this, "currency_historical", { currencyNumber: 12 })
      .then((data) => {
        this["histUSDCOP"] = data;
        this["showLoadingUSDCOP"] = false;
      })
      .catch(function(error) {
        _this["showLoadingUSDCOP"] = false;
        _this["histUSDCOP"] = [];
        console.log(error);
      });
    // ============= get USDMYR data
    this.currencyNumber = 19;
    this.showLoadingUSDMYR = true;
    getCandleData(this, "currency_historical", { currencyNumber: 19 })
      .then((data) => {
        this["histUSDMYR"] = data;
        this["showLoadingUSDMYR"] = false;
      })
      .catch(function(error) {
        _this["showLoadingUSDMYR"] = false;
        _this["histUSDMYR"] = [];
        console.log(error);
      });
  },
  computed: {
    showLoadingAllCalcs() {
      return (
        this.showLoadingFEPCalcs ||
        this.showLoadingMalCalcs ||
        this.showLoadingRottCalcs ||
        this.showLoadingMALUSDCalcs ||
        this.showLoadingUSDCOPCalcs ||
        this.showLoadingUSDMYRCalcs
      );
    },
    showLoadingMalaysia() {
      return this.showLoadingMAL || this.showLoadingFepTable;
    },
    showLoadingMalaysiaUSD() {
      return (
        this.showLoadingMAL ||
        this.showLoadingUSDMYR ||
        this.showLoadingFepTable
      );
    },
    showLoadingRotterdam() {
      return this.showLoadingROTT || this.showLoadingFepTable;
    },
    showLoadingAllUSDCOP() {
      return this.showLoadingUSDCOP || this.showLoadingFepTable;
    },
    showLoadingAllUSDMYR() {
      return this.showLoadingUSDMYR || this.showLoadingFepTable;
    },
  },
  watch: {
    showLoadingFepTable(val) {
      if (val === false) {
        this.fwdUSDCOP = this.fepTableData.map(function(d) {
          return {
            date: d.date,
            id: +d.date,
            close: d.cop,
            curr_fwd: d.cop_fwd,
            curr_ave: d.cop_ave,
            first_day: d.cop_first,
          };
        });
        this.showLoadingFwdUSDCOP = false;
        this.fwdUSDMYR = this.fepTableData.map(function(d) {
          return {
            date: d.date,
            id: +d.date,
            close: d.myr,
            curr_fwd: d.myr_fwd,
            curr_ave: d.myr_ave,
            first_day: d.myr_first,
          };
        });
        this.showLoadingFwdUSDMYR = false;
      }
    },
    showLoadingAllCalcs(val) {
      if (val === false) {
        this.sliceForwards();
        this.consolidateAllData();
        this.calculateAverages();
      }
    },
    showLoadingMalaysia(val) {
      if (val === false) {
        let _this = this;
        this.malaysiaFwdData = this.fepTableData.map(function(d, i) {
          let dat = {
            date: d.date,
            close: d.bmd,
            id: +d.date,
            ave1: d.futures_1,
            ave2: d.futures_2,
            contract1: d.contract_1,
            contract2: d.contract_2,
          };
          if (i === 0) {
            dat["aveKnown"] = d.bmd_ave;
            dat["n1"] = d.n_1;
            dat["n2"] = d.n_2;
          }
          return dat;
        });
        this.malaysiaHistDataMonth = this.malaysiaHistData.filter(
          (d) => d.date >= _this.firstDay,
        );
        this.malaysiaHistData = this.malaysiaHistData.filter(
          (d) => d.date < _this.firstDay,
        );
        this.histSliceAndLoading(
          "malaysiaHistData",
          "malaysiaHistDataSliced",
          "showLoadingMalCalcs",
        );
        this.malaysiaHistDataSliced = this.processData.ohlcNest(
          this.malaysiaHistDataSliced,
          this.interval,
          true,
        );
        this.xRange = this.malaysiaFwdData.map((d) => d.date);
        this.xRange.push(setMax(this.malaysiaFwdData, this.xRange, "1M"));
        this.xRangeFEP = this.malaysiaFwdData.map(
          (d) =>
            new Date(
              new Date(d.date).setMonth(new Date(d.date).getMonth() + 1),
            ),
        );
        this.xRangeFEP.push(setMax(this.malaysiaFwdData, this.xRange, "1M"));
        this.zoomInitial = 0;
        this.zoomFinal = Math.max(1, this.xRange.length - 2);
      }
    },
    showLoadingRotterdam(val) {
      if (val === false) {
        let _this = this;
        let dat = this.fepTableData.map((d) => d);
        this.rotterdamFwdData = dat
          .filter((d) => Number.isFinite(d.rott) && d.rott != null)
          .map(function(d, i) {
            let dat = {
              date: d.date,
              close: d.rott,
              id: +d.date,
              ave1: d.rott,
              ave2: null,
              contract1: d.contract_rott,
              contract2: null,
            };
            if (i === 0) {
              dat["aveKnown"] = d.rott;
              dat["n1"] = d.n_1;
              dat["n2"] = d.n_2;
            }
            return dat;
          });
        this.rotterdamHistDataRaw = this.rotterdamHistData;
        this.rotterdamHistDataMonth = this.rotterdamHistData.filter(
          (d) => d.date >= _this.firstDay,
        );
        this.rotterdamHistData = this.rotterdamHistData.filter(
          (d) => d.date < _this.firstDay,
        );
        this.histSliceAndLoading(
          "rotterdamHistData",
          "rotterdamHistDataSliced",
          "showLoadingRottCalcs",
        );
        this.rotterdamHistDataSliced = this.processData.ohlcNest(
          this.rotterdamHistDataSliced,
          this.interval,
          true,
        );
      }
    },
    showLoadingMalaysiaUSD(val) {
      if (val === false) {
        let _this = this;
        let inputDataByDate = {};
        let keysInputDataByDate = [];
        this.histUSDMYR.forEach(function(d) {
          inputDataByDate[+d.date] = d.close;
          keysInputDataByDate.push(+d.date);
        });
        this.malaysiaUSDHistData = [];
        let cl;
        this.malaysiaHistData
          .concat(this.malaysiaHistDataMonth)
          .forEach(function(d) {
            cl = inputDataByDate[+d.date];
            if (Number.isNaN(cl) || cl == null || cl === 0) {
              keysInputDataByDate.sort((a, b) => {
                return Math.abs(+d.date - a) - Math.abs(+d.date - b);
              });
              cl = inputDataByDate[keysInputDataByDate[0]];
            }
            _this.malaysiaUSDHistData.push({
              date: d.date,
              id: +d.date,
              open: d.open / cl,
              high: d.high / cl,
              low: d.low / cl,
              close: d.close / cl,
            });
          });
        this.malaysiaUSDHistDataMonth = this.malaysiaUSDHistData.filter(
          (d) => d.date >= _this.firstDay,
        );
        this.malaysiaUSDHistData = this.malaysiaUSDHistData.filter(
          (d) => d.date < _this.firstDay,
        );
        let selectedDays = lengthByDate(
          this.pickedIntervalHistory,
          this.malaysiaUSDHistData.map((d) => d.date),
        );
        this.malaysiaUSDHistDataSliced = this.processData.toSlice(
          this.malaysiaUSDHistData,
          selectedDays,
        );
        this.malaysiaUSDHistDataSliced = this.processData.ohlcNest(
          this.malaysiaUSDHistDataSliced,
          this.interval,
          true,
        );
        this.malaysiaFwdUSDData = this.fepTableData.map(function(d, i) {
          let dat = {
            date: d.date,
            close: d.bmd / d.myr,
            id: +d.date,
            ave1: d.futures_1 / d.myr,
            ave2: d.futures_2 / d.myr,
            contract1: d.contract_1,
            contract2: d.contract_2,
          };
          if (i === 0) {
            dat["aveKnown"] = d.bmd_ave / d.myr_ave;
            dat["n1"] = d.n_1;
            dat["n2"] = d.n_2;
          }
          return dat;
        });
        this.showLoadingMALUSDCalcs = false;
      }
    },
    showLoadingAllUSDCOP(val) {
      if (val === false) {
        let _this = this;
        this.fwdUSDCOPSimple = this.fepTableData.map(function(d, i) {
          let dat = {
            date: d.date,
            close: d.cop_first,
            id: +d.date,
            curr_ave: d.cop_first,
          };
          if (i === 0) {
            dat["aveKnown"] = d.cop_ave;
            dat["curr_fwd"] = d.cop_fwd;
            dat["n1"] = d.n_1;
            dat["n2"] = d.n_2;
          }
          return dat;
        });
        this.histUSDCOPMonth = this.histUSDCOP.filter(
          (d) => d.date >= _this.firstDay,
        );
        this.histUSDCOP = this.histUSDCOP.filter(
          (d) => d.date < _this.firstDay,
        );
        this.histSliceAndLoading(
          "histUSDCOP",
          "histUSDCOPSliced",
          "showLoadingUSDCOPCalcs",
        );
        this.histUSDCOPSliced = this.processData.ohlcNest(
          this.histUSDCOPSliced,
          this.interval,
          true,
        );
      }
    },
    showLoadingFEP(val) {
      if (val === false) {
        this.histSliceAndLoading(
          "histFEP",
          "histFEPSliced",
          "showLoadingFEPCalcs",
        );
      }
    },
    showLoadingAllUSDMYR(val) {
      if (val === false) {
        let _this = this;
        this.histUSDMYRMonth = this.histUSDMYR.filter(
          (d) => d.date >= _this.firstDay,
        );
        this.histUSDMYR = this.histUSDMYR.filter(
          (d) => d.date < _this.firstDay,
        );
        this.histSliceAndLoading(
          "histUSDMYR",
          "histUSDMYRSliced",
          "showLoadingUSDMYRCalcs",
        );
        this.histUSDMYRSliced = this.processData.ohlcNest(
          this.histUSDMYRSliced,
          this.interval,
          true,
        );
      }
    },
  },
  methods: {
    onUserSelectMonth(val) {
      this.currMonth = val;
    },
    createImpoExpoData() {
      let _this = this;
      // ====== Rotterdam this month
      this.monthRotterdam = [];
      let usdcopByDate = {};
      let keysUsdcopByDate = [];
      let cl, clAu;
      this.histUSDCOPMonth.forEach(function(d) {
        usdcopByDate[+d.date] = d.close;
        keysUsdcopByDate.push(+d.date);
      });
      this.rotterdamHistDataMonth.forEach(function(d) {
        cl = usdcopByDate[+d.date];
        if (cl === undefined) {
          keysUsdcopByDate.sort((a, b) => {
            return Math.abs(+d.date - a) - Math.abs(+d.date - b);
          });
          cl = usdcopByDate[keysUsdcopByDate[0]];
        }
        clAu =
          (d.close + _this.freightRott) * (1 + _this.tariffRott / 100) * cl;
        _this.monthRotterdam.push({
          id: +d.date,
          date: d.date,
          bmd: d.close,
          usdcop: cl,
          open: clAu,
          high: clAu,
          low: clAu,
          close: clAu,
        });
      });
      // ====== Rotterdam historical
      this.histRottImpoExpo = [];
      usdcopByDate = {};
      keysUsdcopByDate = [];
      this.histUSDCOPSliced.forEach(function(d) {
        usdcopByDate[+d.date] = d.ave;
        keysUsdcopByDate.push(+d.date);
      });
      let dateAu;
      let nDays =
        this.interval === "month" ? 14 : this.interval === "week" ? 4 : 0;
      this.rotterdamHistDataSliced.forEach(function(d) {
        cl = usdcopByDate[+d.date];
        if (cl === undefined) {
          keysUsdcopByDate.sort((a, b) => {
            return Math.abs(+d.date - a) - Math.abs(+d.date - b);
          });
          cl = usdcopByDate[keysUsdcopByDate[0]];
        }
        dateAu = new Date(
          new Date(d.date).setDate(new Date(d.date).getDate() + nDays),
        );
        clAu = (d.ave + _this.freightRott) * (1 + _this.tariffRott / 100) * cl;
        _this.histRottImpoExpo.push({
          id: +d.date,
          date: dateAu,
          bmd: d.ave,
          usdcop: cl,
          open: clAu,
          high: clAu,
          low: clAu,
          close: clAu,
        });
      });
      this.calcHistRottImpoExpoMonthly();
    },
    calcHistRottImpoExpoMonthly() {
      let _this = this;
      let initDate = this.histFEPSliced[0].date;
      let auxData = [];
      let cl, clAu;
      let usdcopByDate = {};
      let keysUsdcopByDate = [];
      this.histUSDCOP
        .filter((d) => d.date >= initDate)
        .forEach(function(d) {
          usdcopByDate[+d.date] = d.close;
          keysUsdcopByDate.push(+d.date);
        });
      this.rotterdamHistDataRaw
        .filter((d) => d.date >= initDate)
        .forEach(function(d) {
          cl = usdcopByDate[+d.date];
          if (cl === undefined) {
            keysUsdcopByDate.sort((a, b) => {
              return Math.abs(+d.date - a) - Math.abs(+d.date - b);
            });
            cl = usdcopByDate[keysUsdcopByDate[0]];
          }
          clAu =
            (d.close + _this.freightRott) * (1 + _this.tariffRott / 100) * cl;
          auxData.push({
            id: +d.date,
            date: d.date,
            bmd: d.close,
            usdcop: cl,
            open: clAu,
            high: clAu,
            low: clAu,
            close: clAu,
          });
        });

      this.histRottImpoExpoMonthly = this.processData.ohlcNest(
        auxData,
        "month",
        true,
      );
      this.histRottImpoExpoMonthly.forEach(function(d) {
        d.close = d.ave;
      });
    },
    consolidateAllData() {
      let _this = this;
      this.allDataFEP = this.fepTableData.map(function(d) {
        return {
          id: +d.date,
          date: d.date,
          bmd: d.bmd / d.myr,
          usdcop: d.cop,
          close:
            (d.bmd / d.myr + _this.freight) * (1 + _this.tariff / 100) * d.cop,
        };
      });
      this.createImpoExpoData();
      this.allDataRotterdam = [];
      this.rotterdamFwdDataSliced.forEach(function(d, i) {
        if (i === 0) {
          _this.allDataRotterdam.push({
            idx: i,
            id: +d.date,
            date: d.date,
            bmd: d.close,
            usdcop: _this.fwdUSDCOPSimple[i].close,
            close:
              (d.close + _this.freightRott) *
              (1 + _this.tariffRott / 100) *
              _this.fwdUSDCOPSimple[i].close,
            ave1:
              (d.aveKnown + _this.freightRott) *
              (1 + _this.tariffRott / 100) *
              _this.fwdUSDCOPSimple[i].ave1,
          });
        } else {
          _this.allDataRotterdam.push({
            idx: i,
            id: +d.date,
            date: d.date,
            bmd: d.close,
            usdcop: _this.fwdUSDCOPSimple[i].close,
            close:
              (d.close + _this.freightRott) *
              (1 + _this.tariffRott / 100) *
              _this.fwdUSDCOPSimple[i].close,
          });
        }
      });
    },
    calculateAverages() {
      let _this = this;
      this.aveDataFEP = {
        bmd: _this.processData.average(_this.allDataFEP.map((d) => d.bmd)),
        usdcop: _this.processData.average(
          _this.allDataFEP.map((d) => d.usdcop),
        ),
        close: _this.processData.average(_this.allDataFEP.map((d) => d.close)),
      };
      this.aveDataRotterdam = {
        bmd: _this.processData.average(
          _this.allDataRotterdam.map((d) => d.bmd),
        ),
        usdcop: _this.processData.average(
          _this.allDataRotterdam.map((d) => d.usdcop),
        ),
        close: _this.processData.average(
          _this.allDataRotterdam.map((d) => d.close),
        ),
      };
    },
    sliceForwards() {
      this.malaysiaFwdDataSliced = this.malaysiaFwdData.slice(
        Math.min(this.malaysiaFwdData.length, this.zoomInitial),
        Math.min(this.malaysiaFwdData.length, this.zoomFinal + 1),
      );
      this.malaysiaFwdUSDDataSliced = this.malaysiaFwdUSDData.slice(
        Math.min(this.malaysiaFwdUSDData.length, this.zoomInitial),
        Math.min(this.malaysiaFwdUSDData.length, this.zoomFinal + 1),
      );
      this.rotterdamFwdDataSliced = this.rotterdamFwdData.slice(
        Math.min(this.rotterdamFwdData.length, this.zoomInitial),
        Math.min(this.rotterdamFwdData.length, this.zoomFinal + 1),
      );
      this.fwdUSDCOPSliced = this.fwdUSDCOP.slice(
        Math.min(this.fwdUSDCOP.length, this.zoomInitial),
        Math.min(this.fwdUSDCOP.length, this.zoomFinal + 1),
      );
      this.fwdUSDCOPSimpleSliced = this.fwdUSDCOPSimple.slice(
        Math.min(this.fwdUSDCOPSimple.length, this.zoomInitial),
        Math.min(this.fwdUSDCOPSimple.length, this.zoomFinal + 1),
      );
      this.fwdUSDMYRSliced = this.fwdUSDMYR.slice(
        Math.min(this.fwdUSDMYR.length, this.zoomInitial),
        Math.min(this.fwdUSDMYR.length, this.zoomFinal + 1),
      );
    },
    histSliceAndLoading(histField, histSlicedField, showLoadingField) {
      let selectedDays = lengthByDate(
        this.pickedIntervalHistory,
        this[histField].map((d) => d.date),
      );
      this[histSlicedField] = this.processData.toSlice(
        this[histField],
        selectedDays,
      );
      this[showLoadingField] = false;
    },
    onUserSelectCPOCurr(val) {
      this.cpoInUSDOrMYR = val;
      this.renderPriceChartSignal += 1;
    },
    onUserSelectCurr(val) {
      this.selectedCOPOrMYR = val;
      this.renderRatesChartSignal += 1;
    },
    onChangeInterval(val) {
      this.pickedIntervalHistory = val;
      this.histSliceAndLoading(
        "malaysiaHistData",
        "malaysiaHistDataSliced",
        "showLoadingMalCalcs",
      );
      this.histSliceAndLoading(
        "malaysiaUSDHistData",
        "malaysiaUSDHistDataSliced",
        "showLoadingMALUSDCalcs",
      );
      this.histSliceAndLoading(
        "rotterdamHistData",
        "rotterdamHistDataSliced",
        "showLoadingRottCalcs",
      );
      this.histSliceAndLoading(
        "histUSDCOP",
        "histUSDCOPSliced",
        "showLoadingUSDCOPCalcs",
      );
      this.histSliceAndLoading(
        "histUSDMYR",
        "histUSDMYRSliced",
        "showLoadingUSDMYRCalcs",
      );
      this.histSliceAndLoading(
        "histFEP",
        "histFEPSliced",
        "showLoadingFEPCalcs",
      );
      this.interval = tIntervalsAnalytics[this.pickedIntervalHistory];
      this.malaysiaHistDataSliced = this.processData.ohlcNest(
        this.malaysiaHistDataSliced,
        this.interval,
        true,
      );
      this.malaysiaUSDHistDataSliced = this.processData.ohlcNest(
        this.malaysiaUSDHistDataSliced,
        this.interval,
        true,
      );
      this.rotterdamHistDataSliced = this.processData.ohlcNest(
        this.rotterdamHistDataSliced,
        this.interval,
        true,
      );
      this.histUSDCOPSliced = this.processData.ohlcNest(
        this.histUSDCOPSliced,
        this.interval,
        true,
      );
      this.histUSDMYRSliced = this.processData.ohlcNest(
        this.histUSDMYRSliced,
        this.interval,
        true,
      );
      this.createImpoExpoData();
      this.callWidth();
    },
    eventMinRange(val) {
      this.zoomInitial = val;
      this.sliceForwards();
      this.consolidateAllData();
      this.calculateAverages();
      this.callWidth();
    },
    eventMaxRange(val) {
      this.zoomFinal = val;

      this.sliceForwards();
      this.consolidateAllData();
      this.calculateAverages();
      this.callWidth();
    },
    onUserFreightChange(val) {
      this.freight = val;
      this.onFreightOrTariffChange();
    },
    onUserFreightChangeRott(val) {
      this.freightRott = val;
      this.onFreightOrTariffChange();
    },
    onUserTariffChange(val) {
      this.tariff = val;
      this.onFreightOrTariffChange();
    },
    onUserTariffChangeRott(val) {
      this.tariffRott = val;
      this.onFreightOrTariffChange();
    },
    onFreightOrTariffChange() {
      this.consolidateAllData();
      this.calculateAverages();
      this.callWidth();
    },
    onUserCompChange(val) {
      this.comp = val;
      populateTableFEPComp(
        this.allDataFEP[1],
        this.allDataRotterdam[1],
        formatNumber,
        timeFormat("%b %y"),
        this.comp,
        this.compRott,
      );
    },
    onUserCompChangeRott(val) {
      this.compRott = val;
      populateTableFEPComp(
        this.allDataFEP[1],
        this.allDataRotterdam[1],
        formatNumber,
        timeFormat("%b %y"),
        this.comp,
        this.compRott,
      );
    },
    callWidth() {
      this.renderPriceChartSignal += 1;
      this.renderRatesChartSignal += 1;
      this.renderFEPSignal += 1;
    },
    // ================= animations ====================
    eventOnClientSelect(idx) {
      if (idx === 1) {
        this.eventMaxRange(this.malaysiaFwdUSDData.length - 1);
      } else if (idx === 2) {
        this.eventMaxRange(this.rotterdamFwdData.length - 1);
      } else if (idx === 3) {
        this.eventMaxRange(this.allDataRotterdam.length - 1);
      }
      this.selectedNavLink = idx;
    },
    expandLeftAnimation() {
      if (!this.expandLeft) {
        this.hideRight = true;
        setTimeout(() => {
          this.expandLeft = !this.expandLeft;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            if (i > 10) {
              this.renderPriceChartSignal += 1;
              this.renderRatesChartSignal += 1;
            }
          }, (i + 1) * 50);
        }
      } else {
        this.expandLeft = !this.expandLeft;
        setTimeout(() => {
          this.hideRight = false;
        }, 100);
        setTimeout(() => {
          this.callWidth();
        }, 300);
      }
    },
    expandRightAnimation() {
      if (!this.expandRight) {
        this.hideLeft = true;
        setTimeout(() => {
          this.expandRight = !this.expandRight;
        }, 50);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderFEPSignal += 1;
          }, (i + 1) * 50);
        }
      } else {
        this.expandRight = !this.expandRight;
        setTimeout(() => {
          this.hideLeft = false;
        }, 100);
        setTimeout(() => {
          this.callWidth();
        }, 300);
      }
    },
  },
};
</script>

<style scoped></style>
